/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFindOneProcessingQueryResponse, DocumentsControllerFindOneProcessingPathParams, DocumentsControllerFindOneProcessingQueryParams, DocumentsControllerFindOneProcessing400, DocumentsControllerFindOneProcessing401, DocumentsControllerFindOneProcessing403, DocumentsControllerFindOneProcessing404 } from "../../models/documentsController/DocumentsControllerFindOneProcessing";

function getDocumentsControllerFindOneProcessingUrl(id: DocumentsControllerFindOneProcessingPathParams["id"], processingId: DocumentsControllerFindOneProcessingPathParams["processingId"]) {
  const res = { method: 'GET', url: `/api/v1/documents/${id}/processing/${processingId}` as const }  
  return res
}

/**
 * @summary Get a processing job by ID
 * {@link /api/v1/documents/:id/processing/:processingId}
 */
export async function documentsControllerFindOneProcessing(id: DocumentsControllerFindOneProcessingPathParams["id"], processingId: DocumentsControllerFindOneProcessingPathParams["processingId"], params: DocumentsControllerFindOneProcessingQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DocumentsControllerFindOneProcessingQueryResponse, ResponseErrorConfig<DocumentsControllerFindOneProcessing400 | DocumentsControllerFindOneProcessing401 | DocumentsControllerFindOneProcessing403 | DocumentsControllerFindOneProcessing404>, unknown>({ method : "GET", url : getDocumentsControllerFindOneProcessingUrl(id, processingId).url.toString(), params, ... requestConfig })  
  return res.data
}